import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import * as ReactUltimatePagination from 'react-ultimate-pagination';
import './pagination.scss';
const PAGES_NUMBER_DESKTOP = 7;
export const Pagination = ({ totalItems, limitPerPage, currentPage, onChange }) => {
    const blockName = 'pagination-block';
    const totalPages = Math.ceil(totalItems / limitPerPage);
    const [shownPagesNumber] = useState(PAGES_NUMBER_DESKTOP);
    useEffect(() => {
        if (currentPage > totalPages) {
            onChange(totalPages, getOffset(totalPages));
        }
    }, [currentPage, totalItems]);
    const cn = (name = null) => {
        return name ? `${blockName}__${name}` : blockName;
    };
    const getOffset = page => (page - 1) * limitPerPage;
    const arrowButton = (props, direction = 'left') => {
        return (<li className={classnames(cn('cell'), cn('cell--arrow'), cn(`cell--arrow-${direction}`))} onClick={props.onClick}>
        <a href="#" className={cn('link')}>
          <svg className={cn('icon')}>
            <use xlinkHref='#pagination-left'/>
          </svg>
        </a>
      </li>);
    };
    const Wrapper = props => {
        return <ul className={cn()}>{props.children}</ul>;
    };
    const Page = props => {
        return (<li className={classnames(cn('cell'), cn('cell--page'), { [cn('cell--active')]: props.isActive }, { [cn('cell--page-first')]: props.value === 1 }, { [cn('cell--page-last')]: props.value === totalPages })} onClick={props.onClick}>
        <a href="#" className={cn('link')}>{props.value}</a>
      </li>);
    };
    const Ellipsis = props => {
        return (<li className={classnames(cn('cell'), cn('cell--page'))} onClick={props.onClick}>
        <a href="#" className={cn('link')}>...</a>
      </li>);
    };
    const PreviousPageLink = props => {
        return arrowButton(props);
    };
    const NextPageLink = props => {
        return arrowButton(props, 'right');
    };
    const itemTypeToComponent = {
        'PAGE': Page,
        'ELLIPSIS': Ellipsis,
        'PREVIOUS_PAGE_LINK': PreviousPageLink,
        'NEXT_PAGE_LINK': NextPageLink,
    };
    const UltimatePagination = ReactUltimatePagination.createUltimatePagination({
        itemTypeToComponent: itemTypeToComponent,
        WrapperComponent: Wrapper
    });
    const onPageChange = page => {
        onChange(page, getOffset(page));
    };
    return (<>
      {totalItems > limitPerPage &&
            (<UltimatePagination currentPage={Math.min(currentPage, totalPages)} totalPages={totalPages} onChange={onPageChange} hidePreviousAndNextPageLinks={totalPages <= shownPagesNumber} hideFirstAndLastPageLinks={true}/>)}
    </>);
};
